import React from 'react';
import { t } from '@lingui/macro';
import clsx from 'clsx';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { PATH_NAMES } from 'utils/routes/pathNames';
import navigationStyles from '../Navigation.module.css';
import { NavItemLink } from '../NavItemLink/NavItemLink';
import { Indicator } from './Indicator/Indicator';
import styles from './WhatsNewButton.module.css';

export const WhatsNewButton = () => {
  const { introducerId } = useIntroducerContext();

  return (
    <div className={clsx(navigationStyles.navItem, styles.navItem)}>
      {introducerId && <Indicator introducerId={introducerId} />}
      <NavItemLink
        className={styles.navItemInner}
        href={PATH_NAMES.whatsNew()}
        label={t`What's new`}
      />
    </div>
  );
};
